(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gm-review-list')) {
  customElements.define('gm-review-list', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const cards = [...this.querySelectorAll('.gm-review-card')];
      const stars = this.querySelector('[data-stars]');
      const photos = this.querySelector('[data-photos]');
      const more = this.querySelector('.gm-review-more');
      const result = this.querySelector('[data-result-count]');
      const empty = this.querySelector('.gm-review-empty');
      const pageSize = Number(this.dataset.pageSize) || 12;
      let limit = pageSize;
      const update = () => {
        const matches = cards.filter(card => (!stars || stars.value === 'all' || card.dataset.rating === stars.value) && (!photos || !photos.checked || card.dataset.photo === 'true'));
        cards.forEach(card => { card.hidden = !matches.includes(card) || matches.indexOf(card) >= limit; });
        if (more) more.hidden = matches.length <= limit;
        if (result) result.textContent = Math.min(limit, matches.length) + ' / ' + matches.length;
        if (empty) empty.hidden = matches.length > 0;
      };
      if (stars) {
        this.querySelector('.gm-review-tools').hidden = false;
        stars.addEventListener('change', () => { limit = pageSize; update(); });
        photos.addEventListener('change', () => { limit = pageSize; update(); });
        more.addEventListener('click', () => { limit += pageSize; update(); });
        update();
      }
      const dialog = this.querySelector('dialog');
      this.querySelectorAll('.gm-review-photo-link').forEach(link => link.addEventListener('click', event => {
        if (!dialog || !dialog.showModal) return;
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        dialog.showModal();
      }));
      dialog?.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
